import { Tab, TabList } from "@ariakit/react";

import styles from "./DiscoverTabs.module.scss";

export function DiscoverTabs({
  label,
  tabs,
}: {
  label: string;
  tabs: { title: string; id: string }[];
}) {
  return (
    <TabList className={styles.tabs} aria-label={label}>
      {tabs.map((tab, index) => {
        return (
          <Tab className={styles.tab} key={index} id={tab.id}>
            {tab.title}
          </Tab>
        );
      })}
    </TabList>
  );
}
